import React from 'react';
import Logo from './assets/logo-bolao-top-cropped.png';

const ExclusaoDados = ({ onBack }) => {
    return (
        <div className="flex flex-col min-h-screen text-slate-200 font-sans bg-slate-900">
            {/* Navigation */}
            <nav className="sticky top-0 z-50 w-full border-b border-slate-700 shadow-lg" style={{ background: 'rgba(30, 41, 59, 0.7)', backdropFilter: 'blur(10px)', paddingTop: 'env(safe-area-inset-top)' }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-20">
                        <div className="flex-shrink-0 flex items-center cursor-pointer hover:opacity-80 transition-opacity" onClick={onBack}>
                            <img src={Logo} alt="Bolões Top" className="h-16 w-auto" />
                        </div>
                        <div>
                            <button
                                onClick={onBack}
                                className="text-slate-300 hover:text-white font-bold py-2 px-4 transition-colors"
                            >
                                Voltar
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-slate-800 rounded-2xl p-8 md:p-12 shadow-xl border border-slate-700">
                    <h1 className="text-3xl md:text-4xl font-bold text-white mb-8 border-b border-slate-700 pb-4">Exclusão de dados do usuário</h1>

                    <div className="space-y-6 text-slate-300 leading-relaxed">
                        <p>
                            O aplicativo BoloesTOP utiliza o Login do Facebook apenas para autenticação do usuário.
                        </p>
                        <p>
                            Não armazenamos dados sensíveis. Caso deseje solicitar a exclusão de quaisquer dados associados à sua conta, siga as instruções abaixo.
                        </p>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">Como solicitar a exclusão dos dados:</h2>

                        <p>
                            Envie um e-mail para: <a href="mailto:contato@boloestop.com.br" className="text-teal-400 hover:underline">contato@boloestop.com.br</a>
                        </p>
                        <p>
                            <strong>Assunto:</strong> Exclusão de dados
                        </p>

                        <p className="mt-4 mb-2">Informe no e-mail:</p>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Nome completo</li>
                            <li>E-mail utilizado no Login</li>
                        </ul>

                        <p className="mt-8 pt-4 border-t border-slate-700 text-sm text-slate-400">
                            Os dados serão excluídos em até 7 dias após a solicitação.
                        </p>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <footer className="bg-slate-950 border-t border-slate-800 pt-12 pb-8 mt-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-600">
                        <p>&copy; 2026 Bolões Top. Todos os direitos reservados.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default ExclusaoDados;
